
window.currentPopupButton = null;
window.tempFreightData = null;

// Helpers: Canonical variant ID and quantity readers
function getVariantId(btnElement) {
    var hiddenInput = document.getElementById('pm-variant-id');
    var val = hiddenInput ? hiddenInput.value : (btnElement ? btnElement.getAttribute('data-variant-id') : null);
    return val ? parseInt(val, 10) : null;
}
function getQuantity() {
    var input = document.getElementById('pm-quantity') || document.getElementById('pm-quantity-inline');
    return input ? (parseInt(input.value, 10) || 1) : 1;
}

// ANA TETİKLEME FONKSİYONU
window.handleAddToCartPopup = function(btnElement, event) {
    
    // 1. Temanın ve tarayıcının varsayılan hareketlerini durdur
    if (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }

    const freightModal = document.getElementById("custom-popup-modal");
    const installModal = document.getElementById("custom-install-modal");

    // Buton üzerindeki verileri oku
    const needInstall = btnElement.getAttribute("data-require-popup-install") === "true";
    const needFreight = btnElement.getAttribute("data-require-popup-transport") === "true";

    // Konsol çıktısı (Hata ayıklama için)
    console.log("Popup Kontrolü:", { needInstall, needFreight });

    // Eğer popup gerekmiyorsa normal sepete ekleme formunu tetikle
    if (!needInstall && !needFreight) {
        const parentForm = btnElement.closest('form');
        if (parentForm) {
            parentForm.submit();
        } else {
            // Form bulunamazsa direkt sepete ekle (AJAX)
            const vId = getVariantId(btnElement);
            const qty = getQuantity();
            fetch("/cart/add.js", { 
                method: "POST", 
                headers: { "Content-Type": "application/json" }, 
                body: JSON.stringify({ id: vId, quantity: qty }) 
            }).then(() => window.location.href = "/cart");
        }
        return true; 
    }

    // Butonu global değişkene kaydet
    window.currentPopupButton = btnElement;

    // Popupları aç
    if (needInstall && installModal) {
        installModal.style.setProperty("display", "block", "important");
    } 
    else if (needFreight && freightModal) {
        freightModal.style.setProperty("display", "block", "important");
    }

    return false; 
};

document.addEventListener("DOMContentLoaded", function () {
    const freightModal = document.getElementById("custom-popup-modal");
    const installModal = document.getElementById("custom-install-modal");
    const freightForm = document.getElementById("popup-question-form");
    const installForm = document.getElementById("popup-install-form");

    const closeButtons = document.querySelectorAll(".close-button, .close-button-install");
    closeButtons.forEach(btn => {
        btn.addEventListener("click", () => {
            if (freightModal) freightModal.style.display = "none";
            if (installModal) installModal.style.display = "none";
        });
    });

    window.addEventListener("click", (e) => {
        if (e.target === freightModal) freightModal.style.display = "none";
        if (e.target === installModal) installModal.style.display = "none";
    });

    // FREIGHT FORM SUBMIT
    if (freightForm) {
        freightForm.addEventListener("submit", function (e) {
            e.preventDefault();
            const phoneInput = document.getElementById("freight-phone");
            const selected = freightForm.querySelectorAll("input[type='radio']:checked");

            if (!phoneInput || phoneInput.value.trim() === "" || selected.length < 2) {
                alert("Please fill all required fields.");
                return;
            }

            const freightData = {};
            selected.forEach(opt => { 
                const cleanName = opt.name.replace(/properties\[(.*?)\]/, '$1');
                freightData[cleanName] = opt.value;
            });
            const cleanPhoneName = phoneInput.name.replace(/properties\[(.*?)\]/, '$1');
            freightData[cleanPhoneName] = phoneInput.value.trim();

            window.tempFreightData = freightData;
            freightModal.style.display = "none";
            if (installModal) installModal.style.setProperty("display", "block", "important");
        });
    }

    // INSTALLATION FORM SUBMIT
    if (installForm) {
        installForm.addEventListener("submit", async function (e) {
            e.preventDefault();
            const selected = installForm.querySelector("input[name='properties[Installation Type]']:checked");
            if (!selected) { alert("Please select an option."); return; }

            if (!window.currentPopupButton) return;
            const installationVariantId = selected.dataset.variantId ? parseInt(selected.dataset.variantId, 10) : null;
            const mainVariantId = getVariantId(window.currentPopupButton);
            const quantity = getQuantity();

            if (!mainVariantId || isNaN(mainVariantId)) {
                alert("Invalid product variant. Please refresh the page.");
                return;
            }

            let mainItemProperties = window.tempFreightData || {};
            if (installationVariantId) mainItemProperties["Installation Type"] = selected.value;

            const itemsToAdd = [{ id: mainVariantId, quantity: quantity, properties: mainItemProperties }];
            if (installationVariantId) itemsToAdd.push({ id: installationVariantId, quantity: 1 });

            try {
                const response = await fetch("/cart/add.js", { 
                    method: "POST", 
                    headers: { "Content-Type": "application/json" }, 
                    body: JSON.stringify({ items: itemsToAdd }) 
                });
                if (!response.ok) {
                    const err = await response.json().catch(function() { return {}; });
                    throw new Error(err.description || err.message || 'Could not add to cart (Error ' + response.status + ')');
                }
                window.location.href = "/cart";
            } catch (error) {
                console.error("Cart error:", error);
                alert("Could not add to cart: " + error.message);
            }
        });
    }
});




/*    window.currentPopupButton = null;
window.tempFreightData = null;

window.handleAddToCartPopup = function(btnElement) {

    
    const freightModal = document.getElementById("custom-popup-modal");
    const installModal = document.getElementById("custom-install-modal");

    const PDP_REQUIRED = window.REQUIRED_POPUP;

    const needInstall = btnElement.getAttribute("data-require-popup-install") === "true" || (PDP_REQUIRED === 'install');
    const needFreight = btnElement.getAttribute("data-require-popup-transport") === "true" || (PDP_REQUIRED === 'freight');

    if (!needInstall && !needFreight) {
        return true; 
    }

    window.currentPopupButton = btnElement;

      if (needInstall && installModal) {
        installModal.style.setProperty("display", "block", "important");
       }

      else if (needFreight && freightModal) {
        freightModal.style.setProperty("display", "block", "important");
       }

    return false; 
};

document.addEventListener("DOMContentLoaded", function () {

    const freightModal = document.getElementById("custom-popup-modal");
    const installModal = document.getElementById("custom-install-modal");

    const freightForm = document.getElementById("popup-question-form");
    const installForm = document.getElementById("popup-install-form");

    const closeFreight = document.querySelector(".close-button");
    const closeInstall = document.querySelector(".close-button-install");

    if (closeFreight) closeFreight.addEventListener("click", () => freightModal.style.display = "none");
    if (closeInstall) closeInstall.addEventListener("click", () => installModal.style.display = "none");
    window.addEventListener("click", function (e) {
        if (e.target === freightModal) freightModal.style.display = "none";
        if (e.target === installModal) installModal.style.display = "none";
    });

    const mainAddToCartButton = document.querySelector('[data-require-popup-install="true"], [data-require-popup-transport="true"]');

    if (mainAddToCartButton) {
        const needInstall = mainAddToCartButton.getAttribute("data-require-popup-install") === "true";
        const needFreight = mainAddToCartButton.getAttribute("data-require-popup-transport") === "true";

        if (needInstall || needFreight) {
            const quickCheckoutContainers = document.querySelectorAll('.shopify-payment-button');

            quickCheckoutContainers.forEach(container => {
                container.style.opacity = '0.4';
                container.style.pointerEvents = 'none'; 
                container.title = 'Please use the "Add to cart" button to select required shipment options.';
            });
        }
    }
    
    if (freightForm) {
        freightForm.addEventListener("submit", function (e) {
            e.preventDefault();

            const phoneInput = document.getElementById("freight-phone");
            const validationRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

            if (!phoneInput || phoneInput.value.trim() === "") {
                alert("Please enter your phone number.");
                return;
            }
            if (!validationRegex.test(phoneInput.value.trim())) {
                alert("Please enter a valid phone number format (e.g., (555) 555-1234 or 555-555-1234).");
                return; 
            }

            const selected = freightForm.querySelectorAll("input[type='radio']:checked");
       
            if (selected.length < 2) { 
                alert("Please select all required options.");
                return;
            }
    
            const freightData = {};
           selected.forEach(opt => { 
                // ✅ DEĞİŞİKLİK BURADA: Anahtarı temizle
                const cleanName = opt.name.replace(/properties\[(.*?)\]/, '$1');
                freightData[cleanName] = opt.value;
                 });  
  
                const cleanPhoneName = phoneInput.name.replace(/properties\[(.*?)\]/, '$1');
                freightData[cleanPhoneName] = phoneInput.value.trim();

                window.tempFreightData = freightData;

            // 2. Freight pop-up'ı kapatılır
            freightModal.style.display = "none";
            
            // 3. Installation pop-up'ı açılır
            const installModal = document.getElementById("custom-install-modal");
            if (installModal) {
                installModal.style.setProperty("display", "block", "important");
            } else {
                // Eğer Installation pop-up yoksa, normal sepet ekleme işlemi devam eder (bir güvenlik önlemi)
                if (window.currentPopupButton) {
                     window.currentPopupButton.closest('form').submit();
                } else {
                    window.location.href = '/cart';
                }
            }
        });
    }


    if (installForm) {
        installForm.addEventListener("submit", async function (e) {
            e.preventDefault();
            
            const selected = installForm.querySelector("input[name='properties[Installation Type]']:checked");
            if (!selected) {
                alert("Please select an installation option.");
                return;
            }

            if (!window.currentPopupButton) return;
            const installationVariantId = selected.dataset.variantId;
            const mainVariantId = window.currentPopupButton.getAttribute("data-variant-id");
            const productHandle = window.currentPopupButton.getAttribute("data-product-handle");

            if (!mainVariantId) {
                alert("Main product ID missing!");
                return;
            }
          
let mainItemProperties = {};

            // ✅ YENİ KISIM: Freight verisi varsa (window.tempFreightData), Properties objesine ekle
            if (window.tempFreightData) {
                mainItemProperties = window.tempFreightData;
                window.tempFreightData = null; // Veriler kullanıldıktan sonra temizle
            }
            
            // Installation verisini de Properties objesine ekle (eğer kurulum seçeneği varsa)
            if (selected && installationVariantId && installationVariantId !== "") {
                mainItemProperties["Installation Type"] = selected.value;
            }


            // 1. "Kurulum İstemiyorum" seçeneği (Installation Variant ID boş)
            // Bu durumda sadece ana ürünü (Freight verisiyle birlikte) sepete ekle
            if (!installationVariantId || installationVariantId === "") {
                await fetch("/cart/add.js", { 
                    method: "POST", 
                    headers: { "Content-Type": "application/json" }, 
                    body: JSON.stringify({ id: mainVariantId, quantity: 1, properties: mainItemProperties }) 
                });
                installModal.style.display = "none";
                window.location.href = "/cart";
                return;
            }

            // 2. Kurulum Gerekiyor (Installation Variant ID dolu)
            
            // Mevcut kurulum ürünlerini sil (Bu mantık aynı kalıyor, ancak artık mainItemProperties'i içeriyor)
            const cart = await fetch("/cart.js").then(r => r.json());
            for (const item of cart.items) {
                if (item.properties && item.properties["Installation Type"] && item.handle === productHandle) {
                    await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ line: item.key, quantity: 0 }) });
                }
            }

            // Ana ürünü (tüm properties ile) ve kurulum ürününü sepete ekle
            const itemsToAdd = [
                { id: mainVariantId, quantity: 1, properties: mainItemProperties }, 
                { id: installationVariantId, quantity: 1 } 
            ];
            
            await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: itemsToAdd }) });

            installModal.style.display = "none";
            window.location.href = "/cart";
        });
    }
});   */